const einProgram = {
  einProgram: {
    pageHeader: 'Prospects et réseau d’installateur Enphase',
    title: 'Affiliation à l’EIN accepté',
    overview: 'Aperçu',
    noCompany: 'Aucune société trouvée',
    goToDashboard: 'Aller sur le tableau de bord',
    messageFromCeo: 'Lire le message de notre PDG',
    companyProfileLink: 'Mettre à jour le profil de votre société',
    serviceAreasLink: 'Sélectionner vos zones de service',
    leadsPreferencesLink: 'Sélectionner vos préférences de prospects',
    reviewInstallerLink: 'Consulter les conditions générales des installateurs',
    open: 'ouvert',
    video: 'vidéo',
    selected: 'sélectionné',
    learnMore: 'En savoir plus',
    completed: 'Terminé',
    pending: 'En attente',
    optInDisabledHeader: 'Programme EIN (Prochainement)',
    optInDisabledDescription:
      'Le Réseau d’installateurs Enphase (EIN) est un bon moyen pour que les propriétaires vous trouvent ! Les propriétaires comptent sur l’EIN pour identifier les installateurs qui offrent les meilleurs standards en matière de service client et de qualité de système lorsqu’ils utilisent les produits Enphase. En tant que membre de l’EIN, vous pourrez profiter de plusieurs avantages qui vous aideront à vendre plus, installer plus et en faire plus.',
    einTier: 'Votre niveau au sein du Réseau d’installateur Enphase (EIN) : ',
    none: 'Aucun',
    viewBenefits: 'Pour voir vos avantages EIN, cliquez ',
    here: 'ici',
    anyQuestions: ' Si vous avez des questions relatives à votre affiliation à l’EIN, veuillez contacter votre',
    enphaseAccountRepresentative: ' responsable commercial Enphase.',
    learnReceivingLeads: 'Savoir comment vous recevrez des prospects depuis la plateforme numérique Enphase ',
    benefitsOfEIN: 'Voir les avantages de l’EIN ',
    contactEnphaseRepresentative:
      '. Veuillez contacter votre représentant de compte Enphase pour en savoir plus sur l’EIN et le programme de prospects Enphase.',
    congratulations: 'Félicitations !',
    whichInstaller: 'Installateur %{tierName}. ',
    invitationText1: 'Vous avez été invité à participer au Réseau d’installateurs Enphase (EIN) en tant que ',
    invitationText2:
      'Le Réseau d’installateurs Enphase (EIN) est notre réseau d’installateurs de confiance qui délivrent une expérience exceptionnelle aux propriétaires lorsqu’ils utilisent les produits Enphase. L’EIN est conçu pour renforcer notre relation avec vous et accélérer votre croissance. En tant que membre de l’EIN, vous pourrez profiter de plusieurs avantages qui vous aideront à vendre plus, installer plus et en faire plus. Veuillez consulter la liste complète des avantages ',
    acceptInvitation: 'Pour accepter votre invitation :',
    acceptTerms: 'J’accepte les conditions générales',
    cellmodemCheck: 'J’accepte les',
    cellmodemTeamcondition: ' conditions générales ',
    cellmodemLinkTitle: 'de la Extension du forfait data du Mobile Connect',
    notEstablished: 'Non établi.',
    contactEin: 'Veuillez contacter votre représentant de compte Enphase pour en savoir plus sur l’EIN.',
    getFreeLeads: 'Pour obtenir des prospects gratuits, veuillez compléter les étapes ci-dessous :'
  }
};

export default einProgram;
